"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QVET_SYSTEM_ARTICLES = void 0;
exports.isQvetSystemArticle = isQvetSystemArticle;
exports.getQvetSystemArticle = getQvetSystemArticle;
exports.QVET_SYSTEM_ARTICLES = [
    {
        qvetCode: 8491,
        description: 'Entrega a cuenta',
        purpose: 'Anticipos de clientes. Cuando alguien deja dinero a cuenta, QVET registra el movimiento contra este artículo. No se vende ni se compra.',
    },
    {
        qvetCode: 8492,
        description: 'Entrega a cuenta (2)',
        purpose: 'Segundo artículo de anticipos, para el otro centro. Mismo papel que el 8491.',
    },
];
const CODES = new Set(exports.QVET_SYSTEM_ARTICLES.map((a) => a.qvetCode));
/** True for an article QVET owns and nobody may write to. */
function isQvetSystemArticle(qvetCode) {
    return qvetCode !== undefined && qvetCode !== null && CODES.has(Number(qvetCode));
}
function getQvetSystemArticle(qvetCode) {
    return exports.QVET_SYSTEM_ARTICLES.find((a) => a.qvetCode === Number(qvetCode));
}
